import { Select } from "antd";
import SportTooltip from "../sport-tooltip/sport-tooltip";
import { isMobile } from "@extensions/design";

/**
 * Компонент для добавления динамической фильтрации
 * @availableFilters - список всех доступных фильтров (type, label, inputType, tooltip?)
 * @usedFilters - список type'ов уже выбранных фильтров
 * @onAdd - обработчик выбора нового фильтра
 * @placeholder - текст в поле выбора
 * @isTooltip - наличие кастомного Tooltip для каждого элемента
 */
const AddFilter = ({ availableFilters, usedFilters = [], onAdd, placeholder = "Добавить фильтр", className = "add-filter"/* , isTooltip = true */}) => {
  const options = availableFilters
    .filter((f) => !usedFilters.includes(f.type))
    .map((f) => ({
      label: f.label,
      value: f.type,
      tooltip: f.tooltip,
    }));

  return (
    <Select
      style={isMobile ? {width: "100%"} : {}}
      showSearch = {false}
      placeholder={placeholder}
      onChange={onAdd}
      className={className}
      allowClear
      options={options.map((opt) => ({
        ...opt,
        label: (
          <SportTooltip title={opt.tooltip } placement="right">
            {opt.label}
          </SportTooltip>
        ),
      }))}
    />
  );
};

export default AddFilter;
